import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { appCredentialsModule } from './modules/appCredentials';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { scaffolderFieldsModule } from './modules/scaffolder';
import { signInModule } from './modules/signIn';

export default createApp({
  features: [
    catalogPlugin,
    appCredentialsModule,
    navModule,
    homeModule,
    scaffolderFieldsModule,
    signInModule,
  ],
});
